
const onPressClose = async (item) => {
    item.style.display = 'none';

    const res = await fetch('/umbraco/Surface/MaintenanceBannerSurface/CloseBanner', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: {}
    });
};

const bannerHandler = (item) => {
  if (!item) return;

  const closeIcon = item?.querySelector('.icon-close');

  if (!closeIcon) return;

  closeIcon.addEventListener('click', () => onPressClose(item));
};

const onMaintenanceBannerLoad = () => {
  const banners = document.querySelectorAll('[data-maintenance-banner]');

  if (!banners.length) return;

  banners.forEach(bannerHandler);
};

export default onMaintenanceBannerLoad;
